import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 预付费接口
 **********************************************************************************/
export default {
	/**
	 * 获取分页数据
	 */
	getFindDataByPage:(name,type,pageIndex,pageSize,success, failure) => {
		Axios.get('/prepayment/page.do', {
			name,
			type,
			pageIndex,
			pageSize,
		}, success, failure);
	},
   /**
    * 保存
	* rate-单价
    */
   getPrepaymentSave(name,type,unit,rate,deviceNo,id, success, failure) {
		Axios.post('/prepayment/save.do', {
			name,
			type,
			unit,
			deviceNo,
			rate,
			id,
		}, success, failure)
	},
	/**
	 * 删除
	 */
	 getDelete(id, success, failure) {
		Axios.get('/prepayment/delete.do', {
			id,
		}, success, failure)
	},
	/**
	 * 获取二维码
	 */
	getQRcode:(unitId,success, failure) => {
		Axios.get('/prepayment/getQRcode.do', {
			unitId,
		}, success, failure);
	},
	/**
	 * 获取已被绑定设备
	 */
	getBindDevices:(success, failure) => {
		Axios.get('/prepayment/getBindDevices.do', {
		}, success, failure);
	},
}
